export default __webpack_public_path__ + "static/blob9-950d0bd48e0c8079f36418c831958fcb.svg";